<div class="row loader">
  <div class="col-md-12 text-center">
    <img src="../../../../assets/loaders/ball-triangle.svg" alt="" [width]="Width" />
  </div>
</div>
